// The one place a server error becomes a sentence. It lived in
// pages/admin/tenants-data.ts and was imported by sixteen files across every
// page family — a lib util wearing a page's address.

import { isAxiosError } from 'axios'

/** Surface the API's human-readable error message (e.g. "el token expiró"),
 *  falling back to a generic message when the error isn't a structured API one. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  if (isAxiosError(err)) {
    const msg = (err.response?.data as { error?: { message?: string } } | undefined)?.error?.message
    if (typeof msg === 'string' && msg.trim() !== '') return msg
  }
  return fallback
}
